import { useAuth } from "@/hooks/useAuth";
import { useSessionTimeout } from "@/hooks/useSessionTimeout";
import { useUploadContext } from "@/contexts/UploadContext";
import { SessionTimeoutDialog } from "./SessionTimeoutDialog";

/**
 * Wraps the app to provide HIPAA-required automatic session timeout.
 * Must be rendered inside the tRPC provider so it can call auth.logout.
 * Suppresses logout while an upload is actively in progress.
 */
export function SessionTimeoutProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  const { isUploadActive } = useUploadContext();
  const { showWarning, secondsLeft, extendSession, doLogout } = useSessionTimeout(isAuthenticated, isUploadActive);

  return (
    <>
      {children}
      <SessionTimeoutDialog
        open={showWarning}
        secondsLeft={secondsLeft}
        onExtend={extendSession}
        onLogout={doLogout}
      />
    </>
  );
}
